import { ModalProps } from "../../interfaces/modal";
import { Input } from "../ui/inputs/Input";
import { usePaymentStore } from "../../stores/payment";
import { showToastError } from "../../services/toast";
import { downloadExportSage } from "../../api/slips";
import { ModalButton, ModalShell } from "../ui/modals/ModalShell";

const ExportSage: React.FC<ModalProps> = ({ closeModal }) => {
  const { formData, setFormData } = usePaymentStore();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    downloadExportSage(formData.dateStart, formData.dateEnd)
      .then((res) => {

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const a = document.createElement("a");
        a.href = url;
        a.download = "export_sage.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        closeModal();
      })
      .catch(() => {
        showToastError("Une erreur est survenue");
      });
  };

  return (
    <ModalShell
      title="Export Sage"
      subtitle="Séléctionner la date de début et de fin pour l'export Sage."
      size="sm"
      onClose={() => closeModal()}
      footer={
        <>
          <ModalButton variant="secondary" onClick={() => closeModal()}>
            Annuler
          </ModalButton>
          <ModalButton
            variant="primary"
            type="submit"
            onClick={(e) => handleSubmit(e)}
          >
            Créer
          </ModalButton>
        </>
      }
    >
      <div className="grid grid-cols-1 gap-3 font-Nunito sm:grid-cols-2">
        <Input
          label="Date de début"
          name="dateStart"
          required
          type="date"
          value={formData.dateStart || ""}
          onChange={handleChange}
          clasName="w-full"
        />
        <Input
          label="Date de fin"
          name="dateEnd"
          required
          type="date"
          value={formData.dateEnd || ""}
          onChange={handleChange}
          clasName="w-full"
        />
      </div>
    </ModalShell>
  );
};

export default ExportSage;
